import CancelIcon from 'ui/CancelIcon';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    colorSecondary: {
        color: theme.palette.green,
    },
});

const StatusIcon = ({ classes, active, size = 'medium' }) => {
    if (active) {
        return (
            <CheckCircleIcon
                fontSize={size}
                className={classes.colorSecondary}
            />
        );
    }
    return <CancelIcon fontSize={size} />;
};

export default withStyles(styles)(StatusIcon);
